var map = {
	"./CompareCategory": 35594,
	"./CompareCategory.jsx": 35594,
	"./CompareConstants": 17850,
	"./CompareConstants.jsx": 17850,
	"./CompareFilter": 65420,
	"./CompareFilter.jsx": 65420,
	"./CompareHelper": 51036,
	"./CompareHelper.jsx": 51036,
	"./CompareRoot": 23821,
	"./CompareRoot.jsx": 23821,
	"./CompareTable": 80350,
	"./CompareTable.jsx": 80350,
	"./CompareTableCells": 81993,
	"./CompareTableCells.jsx": 81993,
	"./CompareToggleDifferences": 18404,
	"./CompareToggleDifferences.jsx": 18404,
	"./CompareVariantNames": 83086,
	"./CompareVariantNames.jsx": 83086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;